import { useEffect } from "react";
import useMyBtStore from "@features/mybt/store/useMyBTStore";
import { MyBtConfigResponse, MyBtTag } from "@features/mybt/utlis/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { FeedTag } from "@routes/Keyword/utils/types";
import { TagType } from "@routes/Section/types";
import { getEnvironment, MYBT_REG_LIMIT } from "@util/constant";
import { getEnvironmentDomain, textToSlug } from "@util/helpers";
import axios from "axios";

/**
 * Hook function to get followed keywords by a user and set them in the store
 */
export const useMyBtFollowedKeywordsInfo = (): void => {
  const { userType, visitorId, isAnonymous, isSubscriber } = useUserInfo();
  const setTags = useMyBtStore((myBtStore) => myBtStore.setTags);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isAnonymous) return;

    setTags([]);
  }, [isAnonymous, setTags]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isAnonymous) return;
    if (visitorId === "") return;

    const domain = getEnvironmentDomain(getEnvironment());

    const fetchFollowedKeywords = async () => {
      const response = await axios.get<MyBtConfigResponse>(
        "/_plat/api/v1/mybt/get-config",
        { headers: { usertype: userType, aovisitorid: visitorId } }
      );

      if (!response.data.tags) return;

      const tagsData = isSubscriber
        ? response.data.tags
        : response.data.tags.slice(0, MYBT_REG_LIMIT);

      const tags: FeedTag[] = tagsData.map(({ name, id }: MyBtTag) => ({
        id,
        name,
        type: TagType.Keyword,
        urlPath: `${domain}/keywords/${textToSlug(name)}`,
      }));

      setTags(tags);
    };

    fetchFollowedKeywords();
  }, [userType, visitorId, isAnonymous, isSubscriber, setTags]);
};
